import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

function HeroCarousel() {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const carouselWords = ["funds","institutions","family offices", "investors","whales", "traders"] ; // TODO: Load this from a CMS

    const [carouselIndex, setCarouselIndex] = useState(1);
    const [carouselWord, setCarouselWord] = useState(carouselWords[0]);
    const [isVisible, setIsVisible] = useState(true);
    const ANIMATION_DURATION = 500;
    const INTERVAL = 2000;

    const show = {
        opacity: 1,
        y: 0,
        transition: {
        duration: ANIMATION_DURATION / 1000
        }
    };
  
  const hide = {
    opacity: 0,
    y: 20,
    transition: {
      duration: ANIMATION_DURATION / 1000
    },
    transitionEnd: {
      y: -20
    },
  };


  // carousel effect every 2 seconds for the title
  useEffect(() => {
    // create interval and change index
    const interval = setInterval(() => {
      setIsVisible(false);

      setTimeout(() => {
        if(carouselIndex < carouselWords.length - 1) {
          setCarouselIndex(carouselIndex + 1);
        } else {
          setCarouselIndex(0);
        }
        
        // update current word
        setCarouselWord(carouselWords[carouselIndex]);
      }, ANIMATION_DURATION);

      setTimeout(() => {
        setIsVisible(true);
      }, ANIMATION_DURATION);
    }, INTERVAL);
  
    return () => clearInterval(interval);
  }, [carouselIndex, carouselWords]);
  
  return(
    <div className='flex flex-row flex-wrap justify-center'>
        <h1 className="text-5xl text-white font-bold mt-4 mb-4 font-tt leading-tight w-1/2 text-right pr-1 max-md:text-3xl max-sm:w-full max-sm:text-center max-sm:mb-0">
        Tailered for
        </h1>
        <motion.h1 
        className="text-5xl text-white font-extrabold mt-4 mb-4 font-tt leading-tight w-1/2 text-left pl-1 underline decoration-blue-400 max-md:text-3xl max-sm:w-full max-sm:text-center max-sm:mt-0"
        animate={isVisible ? show : hide}
        >
        {carouselWord}.
        </motion.h1>
    </div>
  )
}

export default HeroCarousel;